import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "../trpc/client";
import { useMerchant } from "./useMerchant";

export function useOnboardingStatus() {
  const trpc = useTRPC();
  const { merchant } = useMerchant();
  return useQuery({
    ...trpc.merchants.onboardingStatus.queryOptions({
      rentalsMerchantId: merchant?.id ?? "",
    }),
    enabled: !!merchant?.id,
    staleTime: 60_000,
  });
}
